import autoOffIcon from '@disy/cadenza-icons/auto-off.svg';
import autoOnIcon from '@disy/cadenza-icons/auto-on.svg';
import { icon } from '@disy/lib/icon';

import type { IconToggleOptions } from 'ui/icon-toggle/icon-toggle';
import { createIconToggle } from 'ui/icon-toggle/icon-toggle';

import './auto-toggle.css';
import i18n from './auto-toggle.properties';

export function createAutoToggle(options: IconToggleOptions) {
  const toggle = createIconToggle(i18n('title'), icon(autoOffIcon), icon(autoOnIcon), options);
  toggle.classList.add('d-auto-toggle');
  return toggle;
}
